import React from 'react'

import NotificationListItem from './NotificationListItem'

const NotificationList = ({data, onEdit, canEdit, onDelete, canDelete}) => {
  return (
    <div className="d-flex flex-column">
      {data.sort((a, b) => b.id - a.id).map(value => <NotificationListItem onEdit={onEdit} canEdit={canEdit} onDelete={onDelete} canDelete={canDelete} {...value}/>)}
    </div>
  )
}

export default NotificationList